<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="content-section news-container background-light">
			<div class="row">
				<div v-for="item in eventsPaginated" :key="item.ID" class="columns column12">
					<fullwidth-block :item="item" />
				</div>
				<div v-if="events.length > eventsPaginated.length" id="showMoreNews" class="row align-center">
					<button class="button" @click="currentPage++">
						{{ $t('readMore') }}
					</button>
				</div>
			</div>
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: events } = await useWebsiteFetch('events', {
	query: { language: locale.value },
	key: `${locale.value}/events`,
});

const currentPage = ref(1);
const itemsPerPage = 3;

const eventsPaginated = computed(() => {
	return events.value.slice(0, currentPage.value * itemsPerPage);
});
</script>
